import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import type { ResearchReport } from '@pepper/utils/src/types/seo'

interface Parameter {
  data: {
    companyId: string
    reportId?: string
  }
  options?: Pick<UseQueryOptions, 'enabled'>
}

const REFETCH_INTERVAL = 5000

export async function getReport(data: Parameter['data']) {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${data.companyId}/content-research/reports/${data.reportId}`
  try {
    const response = await axios.get(url)
    return extract.data<ResearchReport>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useGetReport({ data, options }: Parameter) {
  return useQuery({
    queryKey: ['research-report', data.reportId],
    queryFn: () => getReport(data),
    refetchInterval: response => {
      if (response) {
        const isProcessing = ['processing', 'pending', 'error'].includes(
          response.generation_status_name
        )

        const isLoadingAiOutline =
          response.generation_status_name === 'completed' &&
          !response.document?.ai_outline?.length

        const shouldRefetch = isProcessing || isLoadingAiOutline

        return shouldRefetch ? REFETCH_INTERVAL : false
      }
      return false
    },
    ...options
  })
}
